import { render, staticRenderFns } from "./GmbReviewLanding.vue?vue&type=template&id=37f8913b&scoped=true"
import script from "./GmbReviewLanding.vue?vue&type=script&lang=js"
export * from "./GmbReviewLanding.vue?vue&type=script&lang=js"
import style0 from "./GmbReviewLanding.vue?vue&type=style&index=0&id=37f8913b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8913b",
  null
  
)

export default component.exports